import React from "react";
import { Link } from "gatsby";
import classNames from "classnames";

type CTAButtonProps = {
  url: string;
  label: string;
  opensInNewTab: boolean;
  type: "primary" | "outline" | "link";
  textStyle: "light" | "dark";
};

export const CTAButton: React.FC<CTAButtonProps> = ({
  url,
  label,
  opensInNewTab,
  type,
  textStyle,
}) => {
  if (opensInNewTab) {
  }

  if (url.startsWith("/") && !opensInNewTab) {
    return (
      <Link
        to={url}
        className={classNames({
          "inline-block rounded bg-primary border border-primary px-5 py-3  text-white font-sansMedium text-base hover:bg-primaryActive focus:outline-none":
            type === "primary",
          "inline-block rounded px-5 py-3 border border-gray-800 text-gray-800 font-sansMedium text-base hover:bg-gray-800 hover:text-white focus:outline-none":
            type === "outline" && textStyle === "dark",
          "inline-block rounded px-5 py-3 border border-white text-white font-sansMedium text-base hover:bg-white hover:text-gray-800 focus:outline-none":
            type === "outline" && textStyle === "light",
        })}
      >
        {label}
      </Link>
    );
  } else {
    return (
      <>
        <a
          rel="noopener"
          target={opensInNewTab ? "_blank" : "_self"}
          href={url}
          className={classNames({
            "inline-block rounded border border-primary bg-primary px-5 py-3 text-white font-sansMedium text-base hover:bg-primaryActive focus:outline-none":
              type === "primary",
            "inline-block rounded px-5 py-3 border border-gray-800 text-gray-800 font-sansMedium text-base hover:bg-gray-800 hover:text-white focus:outline-none":
              type === "outline" && textStyle === "dark",
            "inline-block rounded px-5 py-3 border border-white text-white font-sansMedium text-base hover:bg-white hover:text-gray-800 focus:outline-none":
              type === "outline" && textStyle === "light",
            "inline-block rounded px-5 py-3 text-primary font-sansMedium text-base hover:text-primaryActive focus:outline-none":
              type === "link",
          })}
        >
          {label}
        </a>
      </>
    );
  }
};
